import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const StyledFlagshipLabelWrapper = styled('div')`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const StyledFlagshipLabel = styled(Typography)(
  ({ theme, $impressClinic }) => `
    color: ${$impressClinic ? `hsla(1, 78%, 64%, 1)` : `${theme.DS_palette.label.text}`};
    background-color: ${$impressClinic ? `white` : `${theme.DS_palette.label.bgColor}`};
    border:${$impressClinic ? ` 1px solid hsla(1, 78%, 64%, 1)` : null};
    display: flex;
    align-items: center;
    text-transform: uppercase;
    padding: ${theme.DS_spacing(['xxxs'])} 0.5rem;
    align-self: flex-end;
    border-radius: 50px;
    
    ${theme.breakpoints.up('lg')} {
      padding: ${theme.DS_spacing(['xxxs'])} 0.75rem;
      font-size: 12px;
    }
  `,
);
